export function diagnosticUrl(value) {
    try {
        const url = new URL(String(value), 'https://local.invalid');
        if (!['http:', 'https:'].includes(url.protocol)) return '[dirección omitida]';
        const pathname = url.pathname.replace(/\/(firma-remota|reset-password)\/[^/]+/gi, '/$1/[oculto]');
        return `${url.origin === 'https://local.invalid' ? '' : url.origin}${pathname}`;
    } catch { return '[dirección omitida]'; }
}

export function diagnosticText(value) {
    return String(value || '').replace(/https?:\/\/[^\s"'<>]+/gi, diagnosticUrl)
        .replace(/\bBearer\s+[A-Za-z0-9._~-]+/gi, 'Bearer [oculto]')
        .replace(/\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/g, '[token oculto]')
        .replace(/\b(password|access_token|api_key|secret|authorization)\s*[:=]\s*[^\s,;]+/gi, '$1=[oculto]');
}
